import { render, staticRenderFns } from "./MaintenanceList.vue?vue&type=template&id=6a5b8fa4"
import script from "./MaintenanceList.vue?vue&type=script&lang=js"
export * from "./MaintenanceList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports